export default {
      id: "starts-at-usage",
      viewBox: "0 0 200 60",
      url: __webpack_public_path__ + "sprite.svg#starts-at",
      toString: function () {
        return this.url;
      }
    }